import { render } from "./logosBlock.vue?vue&type=template&id=d63ac180&ts=true"
import script from "./logosBlock.vue?vue&type=script&lang=ts"
export * from "./logosBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__